import { createFileRoute } from '@tanstack/react-router';
import { MagicLinkForm } from '@onesource/components';
import { AuthLayout } from 'src/layouts/auth';

export const Route = createFileRoute('/auth/magic-link')({
  component: () => (
    <AuthLayout>
      <MagicLinkForm redirectUrl={window.location.origin} />
    </AuthLayout>
  ),
});
